export default __webpack_public_path__ + "static/media/wadan.8da3cd1d.png";